var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{attrs:{"id":"app"}},[_c('router-view',{attrs:{"utm":_vm.utm}}),_c('country-select')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }